<!-- 列表容器 -->
<template>
  <div class="list-container" :class="ispadding ? 'container-padding' : ''">
    <div class="list-container-content">
      <!-- 1. title区域 -->
      <div v-if="isTitle" class="title">
        <!-- 左侧title文字 -->
        <div class="text-card">
          <slot name="title"></slot>
        </div>
        <!-- 右侧导出、打印按钮 -->
        <div>
          <!-- <slot name="exportButton"></slot> -->
        </div>
      </div>
      <!-- 2. 查询区域 -->
      <div class="srarch">
        <slot name="srarch"></slot>
      </div>
      <!-- 3. 按钮组 -->
      <div class="button-group">
        <!-- 左侧文字 -->
        <div>
          <slot name="listDescribe"></slot>
        </div>
        <!-- 右侧操作按钮 -->
        <div>
          <slot name="operateButton"></slot>
        </div>
      </div>
      <!-- 4. 列表区域 -->
      <div class="list">
        <slot name="list"></slot>
      </div>
      <!-- 5. 分页 -->
      <div class="pagination">
        <slot name="pagination"></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import { toRefs } from 'vue'
// ispadding 是否显示list-container容器padding值 isTitle是否显示列表title区域
const props = defineProps({
  ispadding: {
    type: Boolean,
    default: true
  },
  isTitle: {
    type: Boolean,
    default: true
  }
})
</script>

<style lang="scss" scoped>
.list-container {
  background-color: #f2f2f2;
  height: 100%;
}

.container-padding {
  padding: 10px;
}

.list-container-content {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  height: 100%;
  padding: 0px 10px 20px;
  padding-right: 0;

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    background-color: #f2f2f2;

    .text-card {
      padding: 0px 20px 0px 15px;
      font-weight: bold;
      color: #1890ff;
      font-size: 14px;
      background-color: #fff;
      line-height: 40px;
    }
  }

  .srarch {
    display: flex;
    align-items: center;
    min-height: 130px;
    border-bottom: 1px solid #e7e4e4;
    padding: 0 10px;

    :deep(.el-form-item) {
      margin-bottom: 0;
    }

    :deep(.el-form .el-form-item) {
      margin-right: 10px;
    }

    :deep(.el-form) {
      display: flex;
      gap: 5px;
      flex-wrap: wrap;
    }

    :deep(.el-form .el-select .select-trigger .el-input) {
      width: 6vw;
    }

    :deep(.el-form .el-date-editor) {
      width: 10vw;
    }

    :deep(.el-form .el-input) {
      width: 8vw;
    }
  }

  .button-group {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 50px;
    font-weight: bold;
    padding-right: 20px;
  }

  .list {
    flex: 1;
    overflow: auto;

    :deep(.el-table) {
      height: 100%;
    }

    :deep(.el-table__header th) {
      background-color: #f5f7fa;
      // border: 0.5px solid #ebeef5;

    }

    :deep(.el-table td) {
      // border: 1px solid #ebeef5;
    }

    :deep(.el-table td::after) {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      border-left: 0.5px solid #ebeef5;
      /* 使用伪元素创建细线边框 */
    }

    :deep(.el-table__header th::after) {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      border-left: 0.5px solid #ebeef5;
      /* 使用伪元素创建细线边框 */
    }
  }

  .pagination {
    display: flex;
    align-items: center;
    height: 40px;
  }
}
</style>
